import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CookiesService } from '../services/cookies.service';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private cookieService: CookiesService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.cookieService.getCookie('access-Token-Cambio-Posadas') !== null && this.cookieService.getCookie('access-Token-Cambio-Posadas') != '') {
      return true;
    } else {
      this.router.navigate(['']);
      return false;
    }
  }
}